import { EqipContractResultsTaskEditor } from './EqipContractResultsTaskEditor'
export * from './types'

export const EqipContractResultsFeatureMap = {
  Component: {
    traitId: 'eqipContractResults' as const,
    TaskEditor: EqipContractResultsTaskEditor,
    selfIsland: true,
  },
  resourceType: 'workflow' as const,
}
